import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

interface TabsProps {
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
  enabledTabs?: string[];
}

const TABS = ["Details", "Instruction"];

const SystemLocationTabs: React.FC<TabsProps> = ({
  selectedTab,
  setSelectedTab,
  enabledTabs = [],
}) => {
  return (
    <div className="main_wrapper_section pills_wrapper ">
      <div className="px-5">
        <Tabs
          activeKey={selectedTab}
          onSelect={(key) => key && setSelectedTab(key)}
          className="mt-3 mb-3 fade-in-left"
        >
          {TABS.map((label) => (
            <Tab
              eventKey={label}
              title={label}
              key={label}
              disabled={enabledTabs.length > 0 && !enabledTabs.includes(label)}
            />
          ))}
        </Tabs>
      </div>
    </div>
  );
};

export default SystemLocationTabs;
